import { ReactNode, useRef, type JSX } from 'react';

import { TimingCard } from '../../atoms';
import type { CommonProps } from '../../types';
import { useDraggableScroll } from '../../useDraggableScroll';
import { PackageCard } from '../package-card';
import { VenueCard, VenueCardProps } from '../venue-card';
import { tv, type VariantProps } from 'tailwind-variants';

export interface CardCollectionProps
    extends CommonProps,
        VariantProps<typeof CardCollectionStyles> {
    children: ReactNode;
}

export const CardCollectionStyles = tv({
    slots: {
        root: 'scrollbar-hide tile-overflow-grid flex overflow-x-scroll lg:-mr-8',
    },
});

export const venueCard = ({
    href,
    name,
    venueId,
}: VenueCardProps): JSX.Element => {
    return <VenueCard href={href} name={name} venueId={venueId} />;
};

export const CardCollection = ({
    className,
    children,
    testId = 'card-collection',
    ...props
}: CardCollectionProps): JSX.Element => {
    const scrollRef = useRef<HTMLDivElement>(null);

    const { mouseDownHandler } = useDraggableScroll(scrollRef.current);

    const { root } = CardCollectionStyles();

    return (
        <div
            data-testid={testId}
            ref={scrollRef}
            className={root({ className })}
            {...props}
            onMouseDown={mouseDownHandler}
        >
            {children}
        </div>
    );
};

CardCollection.VenueCard = venueCard;
CardCollection.PackageCard = PackageCard;
CardCollection.TimingCard = TimingCard;
